import React from "react";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import { UI_THEME, STATUS } from "utils/constants/ui";
import { gridContainer } from "constants/styles";
import { useResizeDetector } from "react-resize-detector";
import { styles } from "./styles";
import { SCHEDULE_LABEL_MAP, SCHEDULE_TYPE } from "utils/constants/price";

const FEATURES = {
  METRIC: "metric",
  MARIELLA: "mariella",
  GRIT: "grit",
  POMPEO: "pompeo"
};

const DOCS_GRID_CONFIG = [
  /**
   * Metric
   * Links
   * Metric Starter
   * https://priceblocs.com/links/JQI77an55plCLUmA6S5Aa
   *
   * Metric Professional
   * https://priceblocs.com/links/6xlAYTBQhKSLAomXYD9IN
   *
   * Metric startup
   * https://priceblocs.com/links/SHLrPvGQ4uMm7ipGLuIbK
   *
   * Metric Enterprise
   * https://priceblocs.com/links/SYT1MbM4MtcE-MssPtc7j
   *
   * Dashboard: https://webflow.com/design/metricdemo-73c209
   * Site: https://metricdemo-73c209.webflow.io/
   */
  {
    id: FEATURES.METRIC,
    label: "Metric",
    category: "Service",
    type: SCHEDULE_TYPE.RECURRING,
    title: "SaaS Tiered Pricing",
    description:
      "Create a pricing table with a variety of different recurring price tiers.",
    url: "https://metricdemo-73c209.webflow.io/#pricing"
  },
  /**
   * Mariella
   * Link priceblocs.com/links/8alPlp5LM4hveMDdmCEtI
   * Dashboard: https: //webflow.com/design/mariellatesst
   * Site: https: //mariellatesst.webflow.io/
   */
  {
    id: FEATURES.MARIELLA,
    label: "Mariella",
    category: "Retail",
    type: SCHEDULE_TYPE.ONE_TIME,
    title: "Retail",
    description: "Sell different products with single payment links for each.",
    url: "https://mariellatesst.webflow.io/"
  },
  /**
   * Grit
   * Bag link: https://priceblocs.com/links/WZYXPQ5wwOde3kWWReoec
   * Dashboard: https://webflow.com/design/gritexample
   * Site: https://gritexample.webflow.io/
   */
  {
    id: FEATURES.GRIT,
    label: "Grit",
    category: "Retail",
    type: SCHEDULE_TYPE.ONE_TIME,
    title: "Single page store",
    description: "Single page e-commerce payments, no coding required.",
    url: "https://gritexample.webflow.io/"
  }
  /**
   * Pompeo
   * Purchase link: https: //priceblocs.com/links/Q-2DmyIU5NTKDkKcRTPHm
   * Site: https://webflow.com/design/potteryexample
   * Dashboard: https://potteryexample.webflow.io/
   */
  // {
  //   id: FEATURES.POMPEO,
  //   label: "Pompeo",
  //   category: "Retail",
  //   type: SCHEDULE_TYPE.ONE_TIME,
  //   title: "Collections",
  //   description: "Sell collections of products with just a single click.",
  //   url: "https://potteryexample.webflow.io/"
  // }
];

const SCHEDULE_THEME = {
  [SCHEDULE_TYPE.RECURRING]: STATUS.PREMIUM,
  [SCHEDULE_TYPE.ONE_TIME]: STATUS.SUCCESS
};

const SiteCell = ({ id, label, title, description, type }) => {
  const { width, height, ref } = useResizeDetector();
  const ctxWidth = width || 0;
  const ctxHeight = height || 0;

  const dimensions = {
    width: ctxWidth,
    height: ctxHeight
  };

  return (
    <div className="w-100">
      <div className="pb3">
        <Pill
          copy={SCHEDULE_LABEL_MAP[type]}
          theme={UI_THEME.SLIM}
          status={SCHEDULE_THEME[type]}
        />
      </div>
      <div className="site_splash--wrapper bl bt br hairline-1 br--top br2">
        <div className={`site_splash site_${id}_splash--img`}></div>
      </div>
      {(description || title) && (
        <div className="pa2 color-text--primary lh-copy word-break bt hairline-1 bl bb br br2 bg-white br--bottom">
          <div className="f6 fw6 pb1">{title}</div>
          <div className="f7">{description}</div>
        </div>
      )}
    </div>
  );
};

const SiteGrid = () => {
  return (
    <div className="w-100">
      <div className="pb4">
        <div className="f2 fw6 tc pb3">⚡️ Live Examples</div>
        <div className="f4 fw5 f3-l tc lh-copy w-100 w-60-ns center black-60">
          Try one of our example sites to see how it works.
        </div>
      </div>
      <div className="grid-container-4 pt3">
        {DOCS_GRID_CONFIG.map((config, gridIx) => {
          return (
            <a href={config.url} target="_blank" className="link">
              <div className="w-100 pb3 pb0-ns cell-grow pointer" key={gridIx}>
                <SiteCell {...config} />
              </div>
            </a>
          );
        })}
        <style jsx>{gridContainer}</style>
        <style jsx>{cellGrow}</style>
        <style jsx>{styles}</style>
      </div>
    </div>
  );
};

export default SiteGrid;
